import React, { Component, Fragment, useEffect, useState } from 'react';
import Header from '../Header';
import Footer from '../Footer';
import cx from '../../../styles';
// import style from './style.css';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import NotificationSystem from 'react-notification-system';
import ComposeContainer from '../../../containers/Compose';
import { gtmSend } from '../../../helpers';
import {
    mobileCheck,
    getUrlParameter,
    readCookie,
    spu_createCookie,
    myIsSet
} from '@tickled-media/web-components.tm-helpers'
import { makeRoute } from '../../../helpers';
import { translate } from 'react-i18next';
import {Icon} from '../../Common/Icon';
import SearchBarContainer from '../../../containers/Search/SearchBar';
// import {adCoreInit} from '../../../components/Ads/Bootstrap';
import ReactStickyPanel from '../../_bit/tm-react-sticky-panel';
import AdCoreSlot from '../../Ads/AdCoreSlot';
import NavigationHeader from '../../NavigationHeader';
import {createShortLink, fetchHeaderMenu, fetchCartData} from '../../../actions';
import DataSharing from '../../DataSharing';

//Deep link for bottom sticky open in app banner
const openInAppLink = {
    "sg": 'https://links.theasianparent.com/77U1bi8qA',
    "id": 'https://links.theasianparent.com/Ist3XcOX3',
    "my": 'https://links.theasianparent.com/p5fQwdprc',
    "th": 'https://links.theasianparent.com/KYwucikwL',
    "ph": 'https://links.theasianparent.com/pHTuwdvdF',
    "vn": 'https://links.beyeu.com/dI2f4u'
}

//Bottom sticky open in app banner
const OpenInApp = (props) => {
    const { t, country: initialCountry, match, postReducer } = props;

    let country = initialCountry;
    const countryList = ["sg", "ph", "id", "my", "vn", "th"];

    country = countryList.includes(country) ? country : 'sg';
    const fallbackLink = openInAppLink[country];

    const handleClick = async() => {
        gtmSend(`download_app`, `Download App`, `Bottom Open in App Button`, `CW mWeb || ${match.url}`, 0 , {action_detail: 'Bottom Open in App Button', platform: 'Mobile Web'})

        if (match.path === '/q/:slug/:id' && postReducer && postReducer.id) {
            try {
                const res = await createShortLink(match.url, 'OpenInAppBanner', country)

                if (res && res.short_link) {
                    window.location.href = res.short_link;
                    return;
                }
            } catch (e) {
                console.error("Failed to create short link:", e);
            }
        }

        window.location.href = fallbackLink;
    }

    return(
        <div className={cx('open-in-app-link')}>
            <div onClick={handleClick} role='button' tabIndex={0}>
                {/*<Icon name="open-in-app-icon" />*/}
                <span>{t('open_in_app')}</span>
            </div>
            <div onClick={props.closeBanner}><Icon name="cross-regular-white-smd" /></div>
        </div>
    );
}

class BaseLayout extends Component {

    constructor (props) {
        super(props);

        let isShowOpenInApp = false;

        if(this.props.serverReqCookie && !readCookie('OpenInAppBannerShown', this.props.serverReqCookie)) {
            isShowOpenInApp = true;
        }
        else if(typeof window !== 'undefined' && !readCookie('OpenInAppBannerShown')) {
            isShowOpenInApp = true;
        }

        this.state = {
            isShowOpenInApp: isShowOpenInApp,
            isAnimateLeft: false,
            isAnimateRight: false,
            isShowNotification: true,
            isLeftSlideOpen: false,
            drawerSource: 'hamburger',
            cartCount : 0
        }

        this._notificationSystem = null;
        //ads
        /*this.dfpArr = [];
        if(typeof window != 'undefined') {
            const ads = props.configReducer.ads;
            if(ads.networkId && props.appReducer.deviceType == 'desktop') {
                this.dfpArr = [
                    {networkId: ads.networkId, unit: ads.common.half_page.unit, id: ads.common.half_page.id, size: [ads.common.half_page.w, ads.common.half_page.h], collapse: true}
                ];
            }
            // else {
                // this.dfpArr = [
                //     {networkId: ads.networkId, unit: ads.mobile.top.unit, id: ads.mobile.top.id, size: [ads.mobile.top.w, ads.mobile.top.h], collapse: true}
                // ];
            // }
            adCoreInit(this.dfpArr);
        }*/
    }

    async componentDidMount() {
        if(!mobileCheck()) {
            this.setState({
                isAnimateLeft: true,
                isAnimateRight: true,
            })
        }

        // if(!this.state.isShowOpenInApp && !readCookie('OpenInAppBannerShown')){
        //     this.setState({
        //         isShowOpenInApp: true
        //     })
        // }

        //Update URL with lng key
        if(!getUrlParameter('lng')) {
            window.history.replaceState({}, "", makeRoute(`${this.props.match.url}${window.location.search}`, this.props.appReducer));
        }

        /*if(this.props.landingUrl !== this.props.match.url){
            window.googletag.cmd.push(function () {
                window.googletag.pubads().refresh();
            })
        }*/
        if (process.env.REACT_APP_SHOP_ACTIVE_IN.indexOf(this.props.appReducer.country) !== -1){
            this.props.fetchCartData(this.props.appReducer.country)
            .then((data) => {
                if(data.status && data.status_code == 200 && data.response){
                    this.setState({ cartCount: data.response.item_count });
                }
            })
            .catch((error) => { return error });
        }

        if(!this.props.appReducer.headerMenu.id && mobileCheck()){
            const country = ['sg', 'th', 'my', 'id', 'vn', 'ph', 'in'].indexOf(this.props.appReducer.country) > -1 ? this.props.appReducer.country : 'sg';
            this.props.fetchHeaderMenu(country);
        }
    }

    componentDidUpdate(prevProps) {
        //system message
        if(prevProps.appReducer.systemMessage.id != this.props.appReducer.systemMessage.id) {
            this.addNotification(this.props.appReducer.systemMessage);
        }

        if(!mobileCheck() && this.refs.rightPanelMain && this.refs.centerPanelMain.offsetHeight <= this.refs.rightPanelMain.offsetHeight && this.state.isAnimateRight) {
            this.setState({
                isAnimateRight: false,
            })
        }

        if(!mobileCheck() && this.refs.leftPanelMain && this.refs.centerPanelMain.offsetHeight <= this.refs.leftPanelMain.offsetHeight && this.state.isAnimateLeft) {
            this.setState({
                isAnimateLeft: false,
            })
        }

        //Update URL with lng key
        if(!getUrlParameter('lng') && prevProps.match.url !== this.props.match.url) {
            window.history.replaceState({}, "", makeRoute(`${this.props.match.url}${window.location.search}`, this.props.appReducer));
        }
    }

    addNotification = (systemMessage) => {
        if(this.state.isShowNotification) {
            this.setState({isShowNotification: false});
            this._notificationSystem.addNotification({
                message: systemMessage.message,
                level: systemMessage.level,
                autoDismiss: systemMessage.autoDismiss ? systemMessage.autoDismiss : 3,
                children: systemMessage.children ? systemMessage.children : null,
                position: 'tc'
            });

            setTimeout(() => {
                this.setState({isShowNotification: true})
            },systemMessage.autoDismiss*1000 ? systemMessage.autoDismiss*1000 : 3000)
        }
    }

    //hide open in app banner on close button click & dont show it for next 24 hrs
    closeBanner = () => {
        spu_createCookie("OpenInAppBannerShown", true, 24);
        gtmSend('dynamic', 'Open In App Banner', 'close', '')

        this.setState({
            isShowOpenInApp: false
        })
    }

    handleLeftSlideOpen = (source = 'hamburger') => {
        if(!this.state.isLeftSlideOpen){
            gtmSend('dynamic', 'Hamburger', 'open', '');
        }
        else{
            gtmSend('dynamic', 'Hamburger', 'close', '');
        }
        this.setState({ isLeftSlideOpen: !this.state.isLeftSlideOpen, drawerSource: source });
    }

    render() {
        const t = this.props.t;
        const dfp = this.props.configReducer.dfp;

        const ifLeftCards = this.props.leftCards && this.props.leftCards.length !== 0 ? true : false;
        const ifRightCards = this.props.rightCards && this.props.rightCards.length !== 0 ? true :false;

        return (
            <div className={`base-layout ${this.props.className || ""} ${this.state.isShowOpenInApp && 'open-in-app'}`}>
                <Header
                    history={this.props.history}
                    userReducer={this.props.userReducer}
                    appReducer={this.props.appReducer}
                    configReducer={this.props.configReducer}
                    postReducer={this.props.postReducer}
                    match={this.props.match}
                    showBackButton={this.props.showBackButton}
                    handleLeftSlideOpen={this.handleLeftSlideOpen}
                    isLeftSlideOpen={this.state.isLeftSlideOpen}
                    drawerSource={this.state.drawerSource}
                    cartCount = {this.state.cartCount}
                />

                <main>

                    <NotificationSystem ref={n => this._notificationSystem = n} />

                    <div id="startMainContentSection"></div>

                    <div className={cx((!ifLeftCards ? "left-panel-decative" : ""), !ifRightCards ? "right-panel-decative" : "", "main-content")}>
                        {
                            ifLeftCards &&
                            <aside className={cx("left-panel")}>
                                <ReactStickyPanel
                                    positionTop={75} positionBottom={15}
                                    isAnimate={ this.state.isAnimateLeft }
                                >
                                    <div className={`left-panel-main`} ref='leftPanelMain'>
                                        {
                                            this.props.leftCards.map((card, i) => {
                                                return <Fragment key={i}>{card}</Fragment>
                                            })
                                        }
                                    </div>
                                </ReactStickyPanel>
                            </aside>
                        }

                        <div className={cx("center-panel")}>
                            <div className={cx("compose-wrap")}>
                                <ComposeContainer isMobile={true} buttonType="textbox" checkVisibility={true} match={this.props.match} />
                            </div>

                            <div ref='centerPanelMain'>
                                {this.props.children}
                            </div>
                        </div>

                        {
                            ifRightCards &&
                            <aside className={cx("right-panel")}>
                                <ReactStickyPanel
                                    positionTop={75} positionBottom={15}
                                    isAnimate={ this.state.isAnimateRight }
                                >
                                    <div className={`right-panel-main`} ref='rightPanelMain'>
                                        {
                                            this.props.match.url !== '/search' &&
                                            <div className={cx("shadow-card")}>
                                                <SearchBarContainer
                                                    match={this.props.match}
                                                />
                                            </div>
                                        }

                                        {
                                            this.props.rightCards.map((card, i) => {
                                                return <Fragment key={i}>{card}</Fragment>
                                            })
                                        }
                                    </div>
                                </ReactStickyPanel>
                            </aside>
                        }
                    </div>
                </main>

                <Footer
                    t={t}
                    config={this.props.configReducer}
                    appReducer={this.props.appReducer}
                    country={this.props.appReducer.country}
                />

                <div className={'bottom-sticky'}>
                    <div className={`bottom-sticky-ad`}>
                        {
                            !(this.props.postReducer && this.props.postReducer.data && this.props.postReducer.data.topic && this.props.postReducer.data.topic.nsfw === 1) &&
                            myIsSet(dfp, 'ros.mobileSticky.side_1.id') &&
                            <AdCoreSlot
                                dfpKeys={['ros', 'mobileSticky', 'side_1']}
                                adObj={dfp.ros.mobileSticky.side_1}
                                device="mobile"
                                //dfpNetworkId={dfp.networkId}
                                //adUnit={dfp.ros.mobileSticky.side_1.unit}
                                customClass=""
                                styleClass={dfp.ros.mobileSticky.side_1.styleClass}
                                //size={[dfp.ros.mobileSticky.side_1.w, dfp.ros.mobileSticky.side_1.h]}
                                //autoRefreshTime={dfp.ros.mobileSticky.side_1.autoRefreshTime}
                                id={dfp.ros.mobileSticky.side_1.id}
                                //articleData={null}
                                overridePlaceholder={true}
                                //country={props.user.country}
                                app={this.props.appReducer}
                                //windowDefined={props.app.windowDefined}
                            />
                        }
                    </div>

                    {
                        <div className={`only-mobile`}>
                            <NavigationHeader
                                appReducer = {this.props.appReducer}
                                userReducer={this.props.userReducer}
                                lng={this.props.lng}
                                t={t}
                                match={this.props.match}
                                handleLeftSlideOpen={this.handleLeftSlideOpen}
                            />
                        </div>
                    }

                    {
                        this.state.isShowOpenInApp &&
                        <div className={`only-mobile`}>
                            <OpenInApp
                                country={this.props.appReducer.country}
                                closeBanner={this.closeBanner}
                                pageName={this.props.className}
                                postReducer={this.props.postReducer}
                                match={this.props.match}
                                t={this.props.t}
                            />
                        </div>
                    }
                    {
                        this.props.userReducer && this.props.userReducer.token &&
                        <DataSharing/>
                    }
                </div>
            </div>
        );
    }

}

BaseLayout.defaultProps = {
    leftCards: [],
    rightCards: []
}

//map state
const mapStateToProps = (state) => {
    return state;
}

//map dispatch
const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
        fetchHeaderMenu,
        fetchCartData
    }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(translate()(BaseLayout));
